import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8dcc17ad-a3fa-4cc7-a0b0-0051ae00fa3c/artifacts/6115fbx7_1ID%20logo%203D.png";

// Brand colours matched to the 3D logo: 1 = steel/silver, i = red, D = blue
export function BrandText({ className = "" }) {
  return (
    <span className={`font-display font-extrabold tracking-tight text-u-ink ${className}`}>
      use
      <span style={{ color: "#8A8F98" }}>1</span>
      <span style={{ color: "#EF4444" }}>i</span>
      <span style={{ color: "#1E40AF" }}>D</span>
    </span>
  );
}

export default function Logo({ to = "/", size = 40, withText = true, spin = true, className = "" }) {
  return (
    <Link to={to} data-testid="brand-logo" className={`flex items-center gap-2.5 ${className}`}>
      <span style={{ perspective: "500px", display: "inline-flex" }}>
        <img
          src={LOGO_URL}
          alt="use1ID"
          style={{ height: size }}
          className={`object-contain ${spin ? "logo-spin" : ""}`}
        />
      </span>
      {withText && <BrandText className="text-lg" />}
    </Link>
  );
}
